var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / User / Contacts") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-User-/-Contacts",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Line",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,22.0000012 L2,22.0000012 C2,17.5817212 5.58172,14.0000012 10,14.0000012 C14.41828,14.0000012 18,17.5817212 18,22.0000012 C18,22.0000012 18,22.0000012 18,22.0000012 L16,22.0000012 L16,22.0000012 C16,18.6862912 13.31371,16.0000012 10,16.0000012 C6.68629,16.0000012 4,18.6862912 4,22.0000012 L2,22.0000012 L2,22.0000012 Z M10,13 C6.685,13 4,10.315 4,7 C4,3.685 6.685,1 10,1 C13.315,1 16,3.685 16,7 C16,10.315 13.315,13 10,13 Z M10,11 C12.21,11 14,9.21 14,7 C14,4.79 12.21,3 10,3 C7.79,3 6,4.79 6,7 C6,9.21 7.79,11 10,11 Z M18.284,14.703 L18.2839996,14.7029998 C21.1545696,15.9958298 23.0003196,18.8517298 22.9999996,21.9999998 L20.9999996,21.9999998 L20.9999997,21.9988099 C20.9999997,19.6374799 19.6152097,17.4956399 17.4619097,16.5265099 L18.2819097,14.7025099 L18.284,14.703 Z M17.596,3.41297878 L17.5960001,3.41297878 C19.6565501,4.26235105 21.0008301,6.27126005 21.0000005,8.50000005 L21.0000005,8.49978877 C21.0009821,11.3440988 18.83277,13.7197688 16.00021,13.9779788 L16.00021,11.9649788 L16.00021,11.9649788 C17.91368,11.6909258 19.24269,9.91758878 18.96864,8.00411878 C18.804304,6.85669878 18.082553,5.86506878 17.04121,5.35597878 L17.59621,3.41297878 L17.596,3.41297878 Z",
    id: "Shape",
    fillOpacity: 0.64,
    fill: "#191923",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/Contacts.10800161b2fdc1854d61847cc6b94ffc.svg";
export { ForwardRef as ReactComponent };